// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__No-Pt","iconWithLink":"styles_iconWithLink__1k1J6","textAsLink":"styles_textAsLink__RpzKP"};